<div class="surface-ground p-4">
    <div class="flex justify-content-between align-items-center mb-4">
        <h2 class="m-0 font-semibold text-base">Analytics</h2>

        <div class="flex gap-2 align-items-center">
            <p-select class="select-date" [options]="dateOptions" [(ngModel)]="selectedDate">
            </p-select>

            <p-button label="Export" rounded="true" variant="text"></p-button>

        </div>
    </div>

    <div class="grid my-3">
        <div class="col-12 md:col-2">
            <p-card>
                <div class="flex justify-content-between align-items-center mb-2 gap-2 p-2">
                    <img src="assets/icons/Icon.svg" alt="icon" />
                </div>
                <div>
                    <h4 class="card-label">Ride Registration</h4>
                    <span class="card-value">935</span>
                </div>
            </p-card>
        </div>
        <div class="col-12 md:col-10">
            <p-card>
                <div class="flex justify-content-between align-items-center mb-2 gap-2 p-2">
                    <img src="assets/icons/Icon (1).svg" alt="icon" />
                </div>
                <div class="flex flex-wrap justify-content-between gap-4">
                    @for (stat of topStats; track $index) {
                    <div class="border-round-md bg-surface-100">
                        <h4 class="card-label">{{ stat.label }}</h4>
                        <span class="card-value">{{ stat.value }}</span>
                    </div>
                    }
                </div>
            </p-card>
        </div>
    </div>


    <div class="grid my-3">
        <div class="col-12 md:col-4">
            <p-card>
                <div class="flex justify-content-between align-items-center mb-2 gap-2 p-2">
                    <img src="assets/icons/Group.svg" alt="icon" />
                </div>
                <div class="flex flex-wrap justify-content-between gap-4">
                    <div>
                        <h4 class="card-label">Subscription rides</h4>
                        <span class="card-value">15</span>
                    </div>
                    <div>
                        <h4 class="card-label">Avg amount</h4>
                        <span class="card-value">15</span>
                    </div>
                </div>
            </p-card>
        </div>
        <div class="col-12 md:col-8">
            <p-card>
                <div class="flex justify-content-between align-items-center mb-2 gap-2 p-2">
                    <img src="assets/icons/Icon (3).svg" alt="icon" />
                </div>
                <div class="flex flex-wrap justify-content-between gap-4">
                    @for (stat of midStats; track $index) {
                    <div class="border-round-md bg-surface-100">
                        <h4 class="card-label">{{ stat.label }}</h4>
                        <span class="card-value">{{ stat.value }}</span>
                    </div>
                    }
                </div>
            </p-card>
        </div>
    </div>


    <div class="grid my-3">
        <div class="col-12">
            <p-card>
                <div class="flex justify-content-between align-items-center mb-2 gap-2 p-2">
                    <img src="assets/icons/Group 1000000945 (1).svg" alt="icon" />
                </div>
                <div class="flex flex-wrap justify-content-between gap-4">
                    @for (stat of bottomStats; track $index) {
                    <div class="border-round-md bg-surface-100">
                        <h4 class="card-label">{{ stat.label }}</h4>
                        <span class="card-value">{{ stat.value }}</span>
                    </div>
                    }
                </div>
            </p-card>
        </div>
    </div>

    <!-- ================= CHARTS ================= -->
    <div class="grid">

        <!-- Reservation Overview -->
        <div class="col-12 sm:col-6">
            <p-card class="shadow-2 border-round-2xl p-3">
                <div class="flex justify-content-between align-items-center mb-3">
                    <h3 class="m-0">Reservation Overview</h3>
                    <p-select class="select-date" [options]="weekOptions" [(ngModel)]="selectedWeek">
                    </p-select>
                </div>

                <p-chart type="bar" [data]="reservationData" [options]="barOptions"></p-chart>
            </p-card>
        </div>

        <div class="col-12 sm:col-6">
            <p-card class="shadow-2 border-round-2xl p-3">
                <h3 class="m-0 mb-3">Top 5 Car Usable</h3>

                <div class="flex flex-wrap align-items-center justify-content-between">
                    <div class=" chart-container">
                        <div class="flex justify-content-center align-items-center">
                            <p-chart class="doughnut-chart" type="doughnut" [data]="carData" [options]="donutOptions"></p-chart>
                        </div>
                        <div class="chart-center-text">
                            <div class="center-number">72,030</div>
                            <div class="center-label">Reservation Car</div>
                        </div>
                    </div>

                    <div>
                        @for (car of carList; track $index) {
                        <div class="flex justify-content-between mb-2 text-sm gap-6 pb-2">
                            <span class="flex align-items-center gap-2">
                                <span class="dot" [style.background]="car.color"></span>
                                {{ car.label }}
                            </span>
                            <span>{{ car.value }}</span>
                        </div>
                        }
                    </div>
                </div>
            </p-card>
        </div>
    </div>

    <!-- ================= KPI ================= -->
    <p-card class="shadow-2 border-round-2xl p-4 mt-4">

        <div class="flex justify-content-between align-items-center mb-3">
            <div>
                <h3 class="m-0">KPI Performance</h3>
                <div class="text-3xl mt-2">76,18%
                    <span class="text-green-500 text-sm">+32% vs last month</span>
                </div>
            </div>

            <p-select [options]="yearOptions" [(ngModel)]="selectedYear">
            </p-select>
        </div>

        <p-chart type="bar" [data]="kpiData" [options]="kpiBarOptions"></p-chart>

    </p-card>

</div>